import { type PaymentType } from 'types/enums.ts'

interface Props {
  baseUrl: string
  method: PaymentType
  reservationId: string
}

export function createReturnUrl({ baseUrl, method, reservationId }: Props) {
  const url = new URL(baseUrl)

  url.searchParams.set('method', method)
  url.searchParams.set('reservationId', reservationId)
  return url.href
}
